import request from "@/utils/request";

//机构
export const branchList = (data) =>
  request({
    url: "/iotBi/branchList",
    method: "GET",
    data,
  });
//websocket
export const getScreenUUid = (params) => {
  return request({
    method: "get",
    url: "/callInfo/bigScreenUUID",
    params,
  });
};

//报警列表
export const listBao = ({ buildingId, status }) =>
  request({
    url: "/callInfo/listBean",
    headers: {
      "Content-Type": "application/json",
    },
    method: "POST",
    data: {
      buildingId,
      status,
    },
  });

//确认
export const getCall = ({ id }) =>
  request({
    url: "/callInfo/responseCall",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    method: "POST",
    params: {
      id: id,
    },
  });
//楼宇
export const getList = ({ branchId }) =>
  request({
    url: "/iotBi/buildingList",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    method: "GET",
    params: {
      branchId: branchId,
    },
  });
